import React from 'react';
import { CheckCircle2Icon, LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { MOCKUP_IMAGE } from '../data/brand';
const chips = ['50 ćwiczeń', '16 tygodni', '3 poziomy', '5 bonusów', 'PDF do druku'];
const assurances = [{
  icon: LockIcon,
  label: 'Bezpieczna płatność'
}, {
  icon: ZapIcon,
  label: 'Natychmiastowy dostęp'
}, {
  icon: ShieldCheckIcon,
  label: '10 dni gwarancji'
}];

/**
 * First screen: title, mockup and the offer button all fit in the viewport
 * on mobile and desktop. Supporting copy sits just below the fold.
 */
export function Hero() {
  return <header id="top" className="bg-ink" data-id="element-79" data-mp="sa027qby5mqy">
      <div className="mx-auto flex min-h-[100svh] max-w-shell flex-col justify-between px-5 py-6 sm:px-6 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-center lg:gap-12 lg:py-10" data-id="element-80" data-mp="nc88qrvnlskn">
        <div className="text-center lg:text-left" data-id="element-81" data-mp="3cz5w0drpe41e">
          <p className="inline-flex items-center gap-2 rounded-full border border-gold/60 bg-gold/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold sm:text-xs" data-id="element-82" data-mp="381e6fqej6u0d">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden="true" data-id="element-83" data-mp="3o7vlzpqpjxzx" />
            Dla nauczycieli gitary jazzowej
          </p>
          <h1 className="mt-4 font-display text-[2.4rem] font-extrabold leading-[0.92] text-white sm:text-6xl lg:mt-5 lg:text-7xl" data-id="element-84" data-mp="39a38120t7hnu">
            Cały semestr gitary jazzowej <span className="text-gold" data-id="element-85" data-mp="30gzwiz9q5evu">gotowy do uczenia.</span>
          </h1>
          <p className="mt-4 hidden max-w-xl text-lg leading-relaxed text-copy-light lg:block" data-id="element-86" data-mp="3599i633t3ssb">
            Plan na 16 tygodni, 50 gotowych ćwiczeń, teoria i 5 bonusów. Wchodzisz, patrzysz i uczysz.
          </p>
          <div className="mt-8 hidden lg:block" data-id="element-87" data-mp="2vi5558xoyi04">
            <CtaButton data-id="element-88" data-mp="2vgu1d948xa90">Chcę gotowy semestr</CtaButton>
          </div>
        </div>

        <div className="flex flex-1 items-center justify-center py-6 lg:flex-none lg:py-0" data-id="element-89" data-mp="2hjovb94j8bdr">
          <img src={MOCKUP_IMAGE} alt="Arsenał Nauczyciela Jazzu: 50 ćwiczeń, 5 bonusów i materiały na komputerze, tablecie i telefonie" className="max-h-[40svh] w-auto max-w-full rounded-2xl object-contain sm:max-h-[46svh] lg:max-h-[78vh]" data-id="element-90" data-mp="2lk8usjckvr32" />
        </div>

        <div className="lg:hidden" data-id="element-91" data-mp="icrmolzp4d74">
          <CtaButton fullWidth data-id="element-92" data-mp="dd5e4putbl4n">Chcę gotowy semestr</CtaButton>
          <ul className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1.5" data-id="element-93" data-mp="deq40266mfw6">
            {assurances.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-[11px] text-copy-soft" data-id="element-94" data-mp="161t06nndyej9">
                <Icon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-95" data-mp="112pv537eo8ba" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-shell px-5 pb-12 sm:px-6 lg:pb-16" data-id="element-96" data-mp="x37bsbv8g5ak">
        <p className="mx-auto max-w-2xl text-center text-base leading-relaxed text-copy-light lg:hidden" data-id="element-97" data-mp="3ltqbtahzursg">
          Arsenał Nauczyciela Jazzu™ to kompletny pakiet: plan semestru na 16 tygodni, 50 gotowych ćwiczeń,
          teoria i 5 bonusów. Wchodzisz, patrzysz i uczysz.
        </p>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2.5 lg:mt-0" data-id="element-98" data-mp="21bxzt9kp90dg">
          {chips.map(chip => <li key={chip} className="flex items-center gap-1.5 text-sm font-medium text-white" data-id="element-99" data-mp="268g3050dsqno">
              <CheckCircle2Icon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-100" data-mp="2b2aiew8yejgy" />
              {chip}
            </li>)}
        </ul>
        <ul className="mt-4 hidden flex-wrap justify-center gap-x-5 gap-y-2 lg:flex" data-id="element-101" data-mp="2kynbbrwoctan">
          {assurances.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 text-sm text-copy-soft" data-id="element-102" data-mp="2p10fwczoql5u">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-103" data-mp="2tyaeoj8ys96c" />
              {label}
            </li>)}
        </ul>
      </div>
    </header>;
}